var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sign-success"},[_c('div',{staticClass:"submit-success"},[_c('img',{staticClass:"submit-img",attrs:{"src":require("@static/images/order/refund/submit.png")}}),_c('div',{staticClass:"t1"},[_vm._v(_vm._s(_vm.text))]),_vm._m(0)])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"t2"},[_vm._v("您可以拨打新华保险客服电话"),_c('a',{attrs:{"href":"tel:95567"}},[_vm._v("95567")]),_vm._v("查询退保进度")])
}]

export { render, staticRenderFns }